module.exports = {
	"articleTitle1": "Burton Tower rings in memory of 9/11 ",
	"catImage": "bluestar.png",
	"totalCats": 1,
	"name": "Burton Bell Tower",
	"videos": [
		"https://www.youtube.com/embed/1Ms2YSeC8LY"
	],
	"articleLink1": "https://www.michigandaily.com/section/campus-life/burton-tower-rings-memory-911",
	"articleLink2": "https://www.michigandaily.com/content/dark-side-campus-history",
	"articleSnippet1": "Sep 11, 2016 ... The School of Music, Theatre & Dance hosted a noontime carillon recital in \nremembrance of 9/11 at Burton Memorial Tower on Sunday.",
	"articleSnippet2": "Sep 8, 2009 ... The Union Tower occupation (Michigan Union) ... architectural centerpiece of the \nUniversity, Burton Memorial Tower carries a stain of infamy ...",
	"totalMisc": 0,
	"articleTitle2": "The dark side of campus history",
	"address": "230 N Ingalls St, Ann Arbor, MI 48109",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160911/agc.NEW_.BellTowerConcert.9.11.16.0017.jpg?itok=w5ZGb41P",
			"author": "Amelia Cacchione",
			"caption": "The School of Music, Theatre & Dance hosted a noontime carillon recital in remembrance of 9/11 at Burton Memorial Tower on Sunday."
		}
	],
	"position": {
		"lat": 42.279474,
		"lng": -83.738718
	},
	"tips": [
		{
			"text": "Top floor of the bell tower is open 12 noon to 12:45 every weekday. Get to hear live carillon music (see the carillon in action!). The views are great too.",
			"person": "Max Kuang"
		}
	],
	"bathroomrating": [
		{
			"rating": 3,
			"bathroom": "Bell Tower"
		}
	],
	"categories": {
		"academics": 1,
		"universitybuilding": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/burtontower.json
// module id = 839
// module chunks = 0